import { fetchQuery, graphql } from "relay-runtime"
import {
  chMagicWandQuery as chMagicWandQueryType,
  MagicWandInput,
} from "@/modules/chats/services/ai/ch/__generated__/chMagicWandQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query chMagicWandQuery($input: MagicWandInput!) {
    magicWand: ch_magicWand(input: $input) {
      ...TextResultFragment @relay(mask: false)
    }
  }
`

export const chMagicWandQuery = (input: MagicWandInput) => {
  return fetchQuery<chMagicWandQueryType>(RelayEnvironment, query, { input }).toPromise()
}
